import * as actions from './actions';
import { isJWTExpired } from './helpers';

const storedAuthorizationToken = localStorage.getItem('authorization-token');

if (storedAuthorizationToken && !isJWTExpired(storedAuthorizationToken)) {
  document.cookie = `authorization-token=${storedAuthorizationToken}; path=/; secure`;
} else {
  document.cookie =
    'authorization-token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC; max-age=0; secure';
}

const initialState = {
  loggedIn:
    !!storedAuthorizationToken && !isJWTExpired(storedAuthorizationToken),
  user: JSON.parse(localStorage.getItem('user') || 'null'),
  token: JSON.parse(localStorage.getItem('token') || 'null'),
  error: null,
};

const sessionReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.LOGIN_USER_SUCCESS:
      return Object.assign({}, state, {
        loggedIn: true,
        user: action.data.profileObj,
        token: action.data.tokenObj,
        error: null,
      });

    case actions.LOGIN_USER_ERROR:
      return Object.assign({}, state, {
        error: action.error,
      });

    case actions.LOGOUT_USER_SUCCESS:
      return Object.assign({}, state, {
        loggedIn: false,
        user: null,
        token: null,
        error: null,
      });

    case actions.LOGOUT_USER_ERROR:
      return Object.assign({}, state, {
        error: action.error,
      });

    case actions.UPDATE_SESSION_WITH_NEW_JWT:
      return Object.assign({}, state, {
        loggedIn: true,
        user: action.user,
        token: action.token,
        error: null,
      });

    default:
      return state;
  }
};

export default sessionReducer;
